// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Complaints from '../complaints/Complaints';
import {actions} from '../duck';
import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    isFetchingComplaints: state.legalConfig.isFetchingComplaints,
    isSaving: state.legalConfig.isSaving,
    saveComplaintsError: state.legalConfig.saveComplaintsError,
    saveComplaintsSuccess: state.legalConfig.saveComplaintsSuccess,
    legalSetting: state.legalConfig.legalSetting,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Complaints);
